import styled from "@emotion/styled";
import {
  Button,
  type ButtonProps,
  createPolymorphicComponent,
  Text,
  type TextProps,
} from "@mantine/core";

export const HomeContainer = styled.div`
  width: 100%;
  padding: 0 5%;
  min-height: calc(100vh - 104px);
  background-color: ${({ theme }) => theme.colors.background[0]};
`;

export const HomeHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 48px;
  padding-top: 16px;
  position: relative;

  > .dateTimeDisplay {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    align-self: center;
  }

  @media (max-width: 940px) {
    > .dateTimeDisplay {
      position: static;
      transform: none;
    }
  }
`;
export const HomeHeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const LogbooksSection = styled.div`
  padding: 40px 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 50px;
  border-radius: 6px;
  ${({ color }: { color: string }) =>
    color
      ? `border: 2px solid ${color};  background-color: rgba(${color.slice(
          4,
          color.length - 1,
        )}, 0.05)`
      : ""};
  width: 100%;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const _HomeDividerText = styled(Text)`
  font-weight: 600;
  font-size: 1.1rem;
  padding: 6px 24px;
`;
export const HomeDividerText = createPolymorphicComponent<"text", TextProps>(
  _HomeDividerText,
);

export const HomeLogbooks = styled.div`
  padding: 25px 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 50px;
`;

export const Separator = styled.div`
  width: 100%;
  height: 2px;
  background-color: #1864ab;
`;

export const NoEntries = styled.p`
  color: #b4b4b4;
  font-style: italic;
`;

const _OpenButton = styled(Button)`
  padding: 8px 12px;
`;

export const OpenButton = createPolymorphicComponent<"button", ButtonProps>(
  _OpenButton,
);

export const _LogName = styled(Text)`
  margin: 0px 0 6px 0;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const LogName = createPolymorphicComponent<"text", ButtonProps>(
  _LogName,
);

export const HomeLogbookOpenBtn = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

export const StyledStatusButton = styled.button<{ active?: boolean }>`
  color: ${({ theme }) => theme.colors.main[6]};
  transition: 0.2s;
  ${({ active, theme }) =>
    active ? `border-bottom: 1px solid ${theme.colors.main[6]};` : ""}

  &:hover {
    color: ${({ theme }) => theme.colors.main[9]};
    border-color: ${({ theme }) => theme.colors.main[9]};
  }
`;

export const LeftSideWrapper = styled.div`
  display: flex;
  min-width: 0;
  flex: 1;
`;
